import React from "react";
import { makeStyles } from "@mui/styles";
import aboutVideo from "../../../assets/Images/about.mp4";

const customStyles = makeStyles({
  root: {
    fontFamily: "Montserrat",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 0",
  },

  video: {
    marginTop: "10px",
    width: "100%",
    objectFit: "cover",
  },

  // ---------- MEDIA QUERIES ----------

  "@media (max-width: 319px)": {
    video: {
      height: "50vh",
    },
  },

  "@media (min-width: 320px) and (max-width: 480px)": {
    video: {
      height: "50vh",
    },
  },

  "@media (min-width: 481px) and (max-width: 768px)": {
    video: {
      height: "50vh",
    },
  },

  "@media (min-width: 769px) and (max-width: 1024px)": {
    video: {
      height: "400px",
    },
  },

  "@media (min-width: 1025px) and (max-width: 1440px)": {
    video: {
      height: "500px",
    },
  },

  "@media (min-width: 1441px)": {
    video: {
      height: "600px",
    },
  },
});


const AboutAlpaaGO = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <video
        className={classes.video}
        src={aboutVideo}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default AboutAlpaaGO;
